import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/lib/seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion/Reveal";
import { SERVICES } from "@/data/services";
import { useBlogPosts } from "@/hooks/content";

const mainPages = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Blog", path: "/blog" },
  { name: "Contact Us", path: "/contact" },
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "Terms of Use", path: "/terms-of-use" },
];

function Group({ title, links }) {
  return (
    <div>
      <h2 className="tech-tag text-brand">{title}</h2>
      <ul className="mt-4 space-y-2.5">
        {links.map((l) => (
          <li key={l.path}>
            <Link to={l.path} className="group inline-flex items-center gap-1.5 text-sm font-medium text-navy transition-colors hover:text-brand-ink">
              {l.name}
              <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Sitemap() {
  // Published articles only — mirrors what /sitemap.xml exposes.
  const { data: posts } = useBlogPosts();

  return (
    <>
      <Seo title="Sitemap" description="Sitemap of the SKY Training & Consultancy website." path="/sitemap" />
      <PageHero eyebrow="Navigation" title="Sitemap" breadcrumb={[{ name: "Home", path: "/" }, { name: "Sitemap", path: "/sitemap" }]} />
      <section className="section-pad">
        <div className="container-sky">
          <Reveal>
            <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-3">
              <Group title="Main Pages" links={mainPages} />
              <Group title="Services" links={SERVICES.map((s) => ({ name: s.title, path: `/services/${s.slug}` }))} />
              <Group
                title="Blog Articles"
                links={(posts || []).map((p) => ({ name: p.title, path: `/blog/${p.slug}` }))}
              />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
